import { render, staticRenderFns } from "./cargos.vue?vue&type=template&id=50016bbb"
import script from "./cargos.vue?vue&type=script&lang=js"
export * from "./cargos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports